import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useChatStore } from '../stores/chat-store';
import { useAuthStore } from '../stores/auth-store';
import ChatBubble from './ChatBubble';
import ChatPanel from './ChatPanel';

interface ChatWidgetProps {
  surface?: 'app' | 'marketing';
  proactiveTrigger?: { type: string; message: string } | null;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({
  surface = 'app',
  proactiveTrigger = null,
}) => {
  const { isOpen, setOpen, conversationId, createConversation } = useChatStore();
  const { user } = useAuthStore();

  // Create conversation when widget first opens
  useEffect(() => {
    if (isOpen && !conversationId) {
      createConversation(surface);
    }
  }, [isOpen, conversationId, createConversation, surface]);

  // Auto-open on proactive trigger
  useEffect(() => {
    if (proactiveTrigger) {
      setOpen(true);
    }
  }, [proactiveTrigger, setOpen]);

  // Hide chat bubble on dashboard (path '/' or '/dashboard')
  const location = useLocation();
  const isDashboard = location.pathname === '/' || location.pathname === '/dashboard';

  if (isDashboard && !isOpen) {
    return null;
  }

  if (isOpen) {
    return <ChatPanel surface={surface} />;
  }

  return <ChatBubble hasNotification={!!proactiveTrigger} showLabel />;
};

export default ChatWidget;
